/**
 * Extracts a human-readable error message from various error formats (plain strings, the
 * backend's FAILED body, Angular HttpErrorResponse), so the store never holds a raw object
 * that a template would print as "[object Object]".
 */
export function extractErrorMessage(error: any): string {
    if (typeof error === 'string') {
        return error;
    }

    // Check for API error format with status and reason fields
    if (error?.status === 'FAILED' && error?.reason) {
        return error.reason;
    }

    // Check for HTTP error response
    if (error?.error) {
        if (typeof error.error === 'string') {
            return error.error;
        }
        if (error.error?.status === 'FAILED' && error.error?.reason) {
            return error.error.reason;
        }
        if (error.error?.message) {
            return typeof error.error.message === 'string' ? error.error.message : String(error.error.message);
        }
        if (error.error?.error) {
            return error.error.error;
        }
        if (error.error?.reason) {
            return error.error.reason;
        }
    }

    // Check for direct message
    if (error?.message) {
        return error.message;
    }

    // Check for reason field at top level
    if (error?.reason) {
        return error.reason;
    }

    // Check for status text
    if (error?.statusText) {
        return `${error.statusText}${error.status ? ` (${error.status})` : ''}`;
    }

    // Avoid surfacing raw serialized errors to the UI (can be noisy and may leak details).
    // Fall back to a generic message if no known shape is matched above.

    return 'An unexpected error occurred. Please try again.';
}
